

















import { defineComponent, ref } from "@vue/composition-api";
import { intervalToDuration } from "date-fns";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import providers from "@/lib/api";
import { getStorageNSFWUserSettings } from "@/lib/nsfwHelpers";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import ConfirmSensitiveContent from "@/components/ConfirmSensitiveContent";

export default defineComponent({
  name: "FeedNsfwNotice",
  components: { ConfirmSensitiveContent, BaseButton, BaseIcon },
  setup() {
    const { authUser } = useAuthUser();
    const { showNotSafeForWork, updateNSFWUserSettings } = useNSFWUserSettings();
    const showConfirm = ref(false);
    const processing = ref(false);

    const onClick = async () => {
      processing.value = true;
      let show = false;

      if (authUser.value) {
        const dateOfBirth = (
          await providers.PersonalInformationProvider.find({
            id: authUser.value.id,
          })
        ).dateOfBirth;
        if (!dateOfBirth || (intervalToDuration({ start: new Date(dateOfBirth), end: new Date() }).years ?? 0) < 18) {
          show = true;
        }
      } else {
        show = !getStorageNSFWUserSettings();
      }

      if (show) {
        showConfirm.value = true;
      } else {
        try {
          await updateNSFWUserSettings(!showNotSafeForWork.value);
        } finally {
          processing.value = false;
        }
      }
    };

    const onResolve = () => {
      showConfirm.value = processing.value = false;
    };

    return { showNotSafeForWork, showConfirm, onClick, onResolve };
  },
});
